<div class="card kpi-green">
    <div class="card-body kpi-card">
        <h5 class="card-title">Nombre d'habitants <i class="fa fa-question-circle" matTooltipClass="tooltip-button" matTooltip="Donnée de {{ EVOL_DEMO_LAST_YEAR }}"></i></h5>
        <p class="card-value">
            <ng-container *ngIf="preview">-</ng-container>
            <ng-container *ngIf="!preview">
                {{ (favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] ? favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] : 0) | number: '1.0-0' }}
            </ng-container>
        </p>
    </div>
</div>
